import TopNav from "ui/dashboard/topnav";
import Layout from "pages/dashboard/map/layout";
import { useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import { AuthContext } from "context/AuthContext";
import { USER_ROLE } from "lib/constants";
import { navLinks } from "ui/dashboard/nav-links";
export default function Page() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    const userRole = user.role;
    navigate(navLinks[userRole]?.at(0)?.href);
  }, []);

  return (
    <>
      <TopNav title="Dashboard" />
      <div className="flex-grow pr-6 pb-6">
        {/* <div className="w-full h-full p-6 rounded-3xl bg-white">
          {user.role === USER_ROLE.Customer && <Layout />}
        </div> */}
      </div>
    </>
  );
}
